import client from '@lib/http/client'

export const validateLandingPageName = (landingName: string) =>
  client.get(`landing-page/validation-name`, {
    params: { name: landingName }
  })
